import {
  DEFAULT_SKILL_EFFECT_FPS,
  SKILL_EFFECT_FRAME_COUNT,
  SKILL_EFFECT_FRAME_HEIGHT,
  SKILL_EFFECT_FRAME_WIDTH,
} from '../constants/skillEffectConfig';

export function buildSkillEffectSheet(skill) {
  const url = skill?.effectFile;
  if (!url) return null;
  return {
    url,
    frameWidth: SKILL_EFFECT_FRAME_WIDTH,
    frameHeight: SKILL_EFFECT_FRAME_HEIGHT,
    frameCount: SKILL_EFFECT_FRAME_COUNT,
    fps: skill.effectFps > 0 ? skill.effectFps : DEFAULT_SKILL_EFFECT_FPS,
  };
}

/** Sürekli aktif (buff) skill mi — efekt süre bitene kadar döngüde kalır */
export function isPersistentSkillEffect(skill) {
  if (!skill) return false;
  return Boolean(
    skill.isBuffSkill
    || skill.isOfke
    || skill.isDefenseBuff
    || skill.isAtesHayaleti
    || skill.isKaranlikKoruma
    || skill.isBuyuluKeskinlik
    || skill.isBuyuluZirh
    || skill.isDehset
  );
}

export function getPersistentEffectUntilMs(skill, result) {
  if (!skill || !result) return 0;
  let sec = 0;
  if (skill.isBuffSkill && !skill.isOfke && !skill.isDefenseBuff) {
    sec = result.buffDurationSec;
  } else if (skill.isOfke) {
    sec = result.rageDurationSec;
  } else if (skill.isDefenseBuff) {
    sec = result.defenseDurationSec;
  } else if (skill.isAtesHayaleti) {
    sec = result.atesHayaletiDurationSec;
  } else if (skill.isKaranlikKoruma) {
    sec = result.darkProtectionDurationSec;
  } else if (skill.isBuyuluKeskinlik) {
    sec = result.buyuluKeskinlikDurationSec;
  } else if (skill.isBuyuluZirh) {
    sec = result.buyuluZirhDurationSec;
  } else if (skill.isDehset) {
    sec = result.dehsetDurationSec;
  }
  return sec > 0 ? Date.now() + Number(sec) * 1000 : 0;
}

const PERSISTENT_BUFF_MAPPINGS = [
  { untilKey: 'attackBuffUntil', match: (s) => s.isBuffSkill && !s.isOfke && !s.isDefenseBuff },
  { untilKey: 'rageSpeedBuffUntil', match: (s) => s.isOfke },
  { untilKey: 'defenseBuffUntil', match: (s) => s.isDefenseBuff },
  { untilKey: 'fireGhostUntil', match: (s) => s.isAtesHayaleti },
  { untilKey: 'darkProtectionUntil', match: (s) => s.isKaranlikKoruma },
  { untilKey: 'buyuluKeskinlikUntil', match: (s) => s.isBuyuluKeskinlik },
  { untilKey: 'buyuluZirhUntil', match: (s) => s.isBuyuluZirh },
  { untilKey: 'dehsetUntil', match: (s) => s.isDehset },
];

/** Aktif buff sürelerine göre kalıcı skill efektlerini senkronize eder */
export function buildPersistentSkillEffects(skills, buffUntils) {
  const now = Date.now();
  const next = {};
  PERSISTENT_BUFF_MAPPINGS.forEach(({ untilKey, match }) => {
    const until = buffUntils[untilKey] || 0;
    if (until <= now) return;
    const skill = skills.find(match);
    if (!skill) return;
    const sheet = buildSkillEffectSheet(skill);
    if (!sheet) return;
    next[skill.id] = { sheet, loop: true, untilMs: until, key: until };
  });
  return next;
}
